<template>
  <div></div>
</template>

<script>
export default {
  name: "ContractBillUpdateDialog",
};
</script>
